import React from "react";
import ProjectsMenu from "../components/Projects/ProjectsMenu";
import Slide from "react-reveal/Slide";

const ProjectsPage = () => {
  return (
    <Slide left>
      <ProjectsMenu />
    </Slide>
  );
};

export default ProjectsPage;
